import { useSrchGoods } from 'api/head/headprdcnetreq-ftech'
import { BottomButton, Button, DatePicker, ListTitle, SearchBar, SelectOption, StateDot, Tag, Text } from 'components'
import { APP_INFO_CONST } from 'constants/app_info_const'
import { format } from 'date-fns'
import useModal from 'hook/useModal'
import { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { isEmptyString } from 'utils/common-util'
import { axiosInstance } from 'api/apiConfig'

// css
import 'assets/style/common.scss'

function ToggleButton({ children }) {
  const [isToggle, setIsToggle] = useState(false)

  return (
    <>
      <Button
        className="btn-show-more"
        text="정보 더보기"
        onClick={() => {
          setIsToggle(!isToggle)
        }}
      />
      {isToggle && children}
    </>
  )
}

// 매뉴검색 검색
function MenuSearch({ keywords = '', ok = () => {} }) {
  const { alertModal, closeModal, openImageViewer } = useModal()
  const userInfo = useRecoilValue(userInfoState)
  const [isInit, setIsInit] = useState(false)
  const [selected, setSelected] = useState(-1)
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  const [queryOptions, setQueryOptions] = useState({
    size: APP_INFO_CONST.PAGE_SIZE,
    page: 1,
    keyword: '',
    baseDt: format(new Date(), 'yyyyMMdd'),
    custOrdrDdlClCd: userInfo.custOrdrDdlClCd,
    // bkmarkYn: 'N',
    // trimSaleYn: 'N',
    siteId: userInfo.siteId,
    shpId: userInfo.shpId,
    gdUsSttsCd: '',
  })

  const { isSuccess, data, fetchNextPage, hasNextPage, refetch } = useSrchGoods(queryOptions, isInit)

  useEffect(() => {
    if (isSuccess) {
      setSelected(-1)
      setTotal(data?.data.length)
      data?.data?.forEach((item, index) => {
        item.goodRecmd = item?.curationDivCd ? item.curationDivCd : item.hotItem ? 'Q50' : ''
      })
      setList(data)
    }
  }, [data])

  useEffect(() => {
    if (!isEmptyString(queryOptions.keyword)) {
      refetch()
    }
  }, [queryOptions])

  const changeDate = (date) => {
    setQueryOptions((prev) => ({ ...prev, baseDt: format(date, 'yyyyMMdd') }))
  }

  // # 빈 객체인지 확인
  // @ 객체가 보유한 데이터 숫자 리턴, 빈 객체라면 0
  function getObjLength(obj) {
    let keyCount = 0
    for (let key in obj) {
      keyCount++
    }
    return keyCount
  }

  return (
    <main className="wrapper">
      <div>
        <Text text="상품명 또는 상품코드로 검색하세요." className="mb16 f-16 f-bold c-3 " />
        <ul className="vertical-form-group" style={{ rowGap: '4px' }}>
          <li>
            <SearchBar
              goSearch={(value) => {
                if (value === '') {
                  alertModal('검색어를 입력해주세요.')
                  return
                }
                setQueryOptions({
                  ...queryOptions,
                  keyword: value,
                })
              }}
            />
          </li>
          <li>
            <DatePicker changeDate={changeDate} />
          </li>
          <li>
            <SelectOption
              value={queryOptions.gdUsSttsCd}
              list={[
                {
                  text: '전체',
                  value: '',
                },
                {
                  text: '정상',
                  value: '0,1,2',
                },
                {
                  text: '중단',
                  value: '3,4',
                },
              ]}
              onChange={(e) => setQueryOptions((prev) => ({ ...prev, gdUsSttsCd: e.target.value }))}
            />
          </li>
        </ul>
      </div>

      <section
        className="mt24"
        style={{
          marginBottom: '70px',
        }}
        // 스타일 조정
      >
        <div className="flex-between">
          <ListTitle title="검색결과" count={total || 0} />
          {/* <div>
            <InputCheckbox
              name="bkmarkYn"
              className="mr16"
              title="즐겨찾기"
              onChange={(event) =>
                setQueryOptions({
                  ...queryOptions,
                  bkmarkYn: event.target.checked ? 'Y' : 'N',
                })
              }
              checked={queryOptions.bkmarkYn === 'Y'}
            />
            <InputCheckbox
              name="trimSaleYn"
              className="mr16"
              title="3개월"
              onChange={(event) =>
                setQueryOptions({
                  ...queryOptions,
                  trimSaleYn: event.target.checked ? 'Y' : 'N',
                })
              }
              checked={queryOptions.trimSaleYn === 'Y'}
            />
          </div> */}
        </div>
        <ul className="border-list mb40">
          {list?.data
            ?.sort((a, b) => {
              // 오름

              // 첫 번째 정렬 기준이 같으면 두 번째 정렬 기준을 검사
              return a['goodRecmd'] > b['goodRecmd'] ? -1 : 1
            })
            .map((item, index) => {
              //list?.data?.map((item, index) => {
              const {
                gdNo,
                gdBd,
                gdUsSttsCd,
                imgCnt,
                bkmark,
                trimSale,
                strgCondNm,
                crtMngClNm,
                ordrUnitCd,
                irdsRto,
                curationDivCd,
                critBuyUnprc,
                trfUnprc,
                hotItem,
                ddlPct,
                ddlHmi,
                endYmd,
                gtrfUnprc,
                imgUrl,
                goodRecmd,
              } = item

              // {ddlPct ? `D-${ddlPct} ${ddlHmi.slice(0, 2)}:${ddlHmi.slice(2)}` : ''}
              const Tags = []

              // if (ddlPct)
              //   Tags.push({
              //     text: `D-${ddlPct} ${ddlHmi?.slice(0, 2)}:${ddlHmi?.slice(2)}`,
              //     color: 'gray',
              //   })

              // if (gdUsSttsCd === '2') {
              //   Tags.push({
              //     text: '금지',
              //     color: 'red',
              //   })
              // }
              if (goodRecmd === 'Q40') {
                Tags.push({
                  text: '프로모션',
                  color: 'gray',
                })
              }
              if (goodRecmd === 'Q90') {
                Tags.push({
                  text: '최저가',
                  color: 'blue',
                })
              }
              if (goodRecmd === 'Q10') {
                Tags.push({
                  text: '할인',
                  color: 'gray',
                })
              }
              if (goodRecmd === 'Q50') {
                Tags.push({
                  text: '인기',
                  color: 'orange',
                })
              }
              if (goodRecmd === 'Q20') {
                Tags.push({
                  text: 'NEW',
                  color: 'blue',
                })
              }

              // if (irdsRto !== 0) {
              //   Tags.push({
              //     text: `${irdsRto > 0 ? '▴' : irdsRto < 0 ? '▾' : ''} ${Math.round(irdsRto || 0)}%`,
              //     color: irdsRto > 0 ? 'red-line' : irdsRto < 0 ? 'blue-line' : 'gray',
              //   })
              // }

              return (
                <li key={gdNo} className={selected === index ? 'active' : ''} onClick={() => setSelected(index)}>
                  {Tags.length > 0 && <Tag className="mb0" data={Tags} />}
                  <div className="flex-between">
                    <Text className="mt8 f-14 f-500">
                      [{gdNo}] {gdBd}
                    </Text>
                    <StateDot color={gdUsSttsCd === '0' ? 'success' : gdUsSttsCd === '2' ? 'warning' : 'error'} />
                  </div>
                  <Text className="mt4 f-12 mono-6">
                    단가 {parseInt(trfUnprc || 0).toLocaleString()}원(100g당 {parseInt(gtrfUnprc).toLocaleString()}
                    원)
                  </Text>

                  <section className="flex-col mt12">
                    {/* 하단 내용 show/hide 제어 버튼 */}
                    {/* <ToggleButton>
                    <div className="hide/show"> */}
                    <ul className={`info-list data-right col-2 level-2`}>
                      <li
                        onClick={(e) => {
                          e.preventDefault()
                          axiosInstance.post('/api/thumbImg/v1.0/thumbImgList', { gdNo: gdNo }).then((res) => {
                            const images = res.data
                              .filter((item) => item.thmnlYn === '0')
                              .map(function (item) {
                                return {
                                  src:
                                    process.env.REACT_APP_PRODUCT_MENU_IMAGE_URL +
                                    '/' +
                                    item['gdNo'] +
                                    '/' +
                                    item['gdImgFileRoutUrl'],
                                  cTTL: true,
                                }
                              })
                            openImageViewer(images)
                          })
                        }}
                      >
                        <span className="label" style={{ width: '60px' }}>
                          사진
                        </span>
                        <span className={`data`}>{imgCnt > 0 ? 'Y' : 'N'}</span>
                      </li>
                      <li>
                        <span className="label" style={{ width: '60px' }}>
                          원산지
                        </span>
                        <span className={`data`}>{crtMngClNm}</span>
                      </li>
                      <li>
                        <span className="label" style={{ width: '60px' }}>
                          저장조건
                        </span>
                        <span className={`data`}>{strgCondNm}</span>
                      </li>
                      <li>
                        <span className="label" style={{ width: '60px' }}>
                          주문단위
                        </span>
                        <span className={`data`}>{ordrUnitCd}</span>
                      </li>
                    </ul>
                    {/* <InfoList
                    level="2"
                    dataAlign="right"
                    data={[
                      { id: 1, title: '사진', data: imgCnt > 0 ? 'Y' : 'N' },
                      { id: 4, title: '원산지', data: crtMngClNm },
                      { id: 5, title: '저장조건', data: strgCondNm },
                      { id: 6, title: '주문단위', data: ordrUnitCd },
                    ]}
                  /> */}
                    {/* </div>
                  </ToggleButton> */}
                  </section>
                </li>
              )
            })}
        </ul>
        {hasNextPage && <Button type="more" className="mt24" onClick={() => fetchNextPage()} />}
      </section>
      <BottomButton
        data={[{ title: '선택', color: 'primary' }]}
        onClick={() => {
          if (selected < 0) {
            alertModal('상품을 선택해주세요.')
            return
          }

          ok(list.data[selected])
          closeModal()
        }}
      />
    </main>
  )
}

export default MenuSearch
